<template>
    <div class="chart-card" :style="{ padding: normalizeSize(20, true) }">
        <div class="chart-header">
            <div class="chart-title-section">
                <h3 class="chart-title poppinsSemiBold" :style="{ fontSize: normalizeFontSize(18) }">{{ title }}</h3>
                <div v-if="variation !== null" class="chart-variation">
                    <span :class="variationClass">{{ variationText }}</span>
                    <span class="variation-label">{{ variationLabel }}</span>
                </div>
            </div>
            <div class="chart-legend" v-if="showLegend && legendItems.length">
                <div v-for="item in legendItems" :key="item.label" class="legend-item">
                    <span class="legend-color" :style="{ background: item.color }"></span>
                    <span class="legend-label" :style="{ fontSize: normalizeFontSize(14) }">{{ item.label }}</span>
                </div>
            </div>
        </div>
        <div class="chart-content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import normalizeSize from '../../../../utils/normalizeSize'
import normalizeFontSize from '../../../../utils/normalizeFontSize'
export default {
    name: 'ChartCard',
    props: {
        title: {
            type: String,
            required: true,
        },
        variation: {
            type: Number,
            default: null,
        },
        variationLabel: {
            type: String,
            default: '',
        },
        showLegend: {
            type: Boolean,
            default: true,
        },
        legendItems: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        variationClass() {
            if (this.variation === null) return ''
            return this.variation >= 0 ? 'positive' : 'negative'
        },
        variationText() {
            if (this.variation === null) return ''
            const sign = this.variation >= 0 ? '+' : ''
            return `${sign}${this.variation}%`
        },
    },
    methods: {
        normalizeFontSize,
        normalizeSize,
    },
}
</script>

<style scoped>
.chart-card {
    width: 100%;
    border-radius: 20px;
    background: linear-gradient(135deg, rgba(20, 25, 60, 0.95) 0%, rgba(15, 18, 45, 0.92) 100%);
    backdrop-filter: blur(60px);
    border: 1px solid rgba(74, 58, 255, 0.15);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
    transition:
        transform 0.3s ease,
        box-shadow 0.3s ease;
    overflow-x: auto;
}

.chart-card:hover {
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.3);
    border-color: rgba(255, 255, 255, 0.1);
}

.chart-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 20px;
    flex-wrap: wrap;
    gap: 15px;
}

.chart-title-section {
    display: flex;
    align-items: center;
    gap: 10px;
}

.chart-title {
    color: #fff;
    line-height: 140%;
    margin: 0;
}

.chart-variation {
    display: flex;
    align-items: center;
    gap: 5px;
    color: #a0aec0;
    font-family: Poppins, sans-serif;
    font-size: clamp(12px, 0.729545vw, 16px);
    font-weight: 400;
    line-height: 140%;
}

.chart-variation .positive {
    color: #01b574;
    font-weight: 700;
}

.chart-variation .negative {
    color: #c52b21;
    font-weight: 700;
}

.variation-label {
    color: #a0aec0;
}

.chart-legend {
    display: flex;
    align-items: center;
    gap: 15px;
}

.legend-item {
    display: flex;
    align-items: center;
    gap: 8px;
}

.legend-color {
    width: 9px;
    height: 9px;
    border-radius: 50%;
}

.legend-label {
    color: #fff;
    font-family: Inter, sans-serif;
    font-weight: 400;
    line-height: 16px;
}

.chart-content {
    width: 100%;
    min-height: 200px;
    height: 86%;
    overflow: visible;
    display: flex;
    justify-content: space-between;
}

@media (max-width: 640px) {
    .chart-header {
        flex-direction: column;
        gap: 10px;
    }
}
</style>
